var DecemberSaleImage = require('misc/december-sale-banner.png')
var OctoberSaleImage = require('misc/halloween-sale-banner.png')
var JulySaleImage = require('misc/july-sale-banner.png')
var SeptemberSaleImage = require('misc/september-sale-banner.png')
var ShopSales = {
	SALES: [
		{
			"title": "Owl-idays Sale",
			"description": "A few wintery items are now available for you to buy. Will you choose a tree costume or a pet snowman?",
			"start_month": 11,
			"start_day": 1,
			"end_month": 0,
			"end_day": 14,
			"patches": [
				{
					"name": "beard-santa",
					"title": "Santa Owl Beard",
					"description": "Ho, ho, ho... or is it Hoot, Hoot, Hoot?",
					"source": "special",
					"patch_type": "face",
					"origin_patch_type": "face",
					"patch_directory": "face",
					"z_index": 1700,
					"price": 180,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				},
				{
					"name": "antlers",
					"title": "Rudolph's Antlers",
					"description": "Wear these antlers and then all you need is a bright red nose to lead Santa's sleigh through the night.",
					"source": "special",
					"patch_type": "head",
					"origin_patch_type": "head",
					"patch_directory": "head",
					"z_index": 1900,
					"price": 60,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 8,
					"extra_bottom": 0
				},
				{
					"name": "holly",
					"title": "Owly's Holly",
					"description": "Each December, Owls from the all over the world fly with holly branches and sing songs of joy and hot cocoa.",
					"source": "special",
					"patch_type": "head",
					"origin_patch_type": "head",
					"patch_directory": "head",
					"z_index": 1400,
					"price": 40,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 20,
					"extra_bottom": 0
				},
				{
					"name": "santa-hat",
					"title": "Holly Jolly Hat",
					"description": "The owner of this hat is given a very special power: the ability to know the perfect gift to give to their family and friends. Become the best gift giver with this jolly hat.",
					"source": "special",
					"patch_type": "head",
					"origin_patch_type": "head",
					"patch_directory": "head",
					"z_index": 1400,
					"price": 60,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 20,
					"extra_bottom": 0
				},
				{
					"name": "tree-top",
					"title": "Tree Star",
					"description": "This star will make it easy for all your friends to find you at night. In fact it will bring them to you. Be the host of the greatest holiday parties with this star!",
					"source": "special",
					"patch_type": "head",
					"origin_patch_type": "head",
					"patch_directory": "head",
					"z_index": 1400,
					"price": 60,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 20,
					"extra_bottom": 0
				},
				{
					"name": "tree-bottom",
					"title": "Tree Pants",
					"description": "Do you love pants but wish they smelled like delicious pine trees? If so, today is your lucky day. Tree pants are super stylish this time of year.",
					"source": "special",
					"patch_type": "body",
					"origin_patch_type": "body",
					"patch_directory": "body",
					"z_index": 1500,
					"price": 60,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				},
				{
					"name": "hannukaih",
					"title": "Hannukiah",
					"description": "Be the light in the world! Share your love, wisdom, and good energy with this Hannukiah!",
					"source": "special",
					"patch_type": "hand",
					"origin_patch_type": "hand",
					"patch_directory": "hand",
					"z_index": 3000,
					"price": 200,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				},
				{
					"name": "dreidel",
					"title": "Dreidel",
					"description": "Owls love spinning the dreidel! Try your luck and hope for a gimel.",
					"source": "special",
					"patch_type": "hand",
					"origin_patch_type": "hand",
					"patch_directory": "hand",
					"z_index": 3000,
					"price": 200,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				},
				{
					"name": "gift",
					"title": "Best-Ever Holiday Present",
					"description": "Do you like surprises? Well this present contains a surprise. You're going to have to use your imagination though, because we're not going to tell you what's inside.",
					"source": "special",
					"patch_type": "hand",
					"origin_patch_type": "hand",
					"patch_directory": "hand",
					"z_index": 3000,
					"price": 200,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				},
				{
					"name": "mini-snowman",
					"title": "Tiny Snowman",
					"description": "Snowmen and owls have been friends since the beginning of time. Why? Maybe because they both are very wise, or maybe because they both can never get enough popcorn.",
					"source": "special",
					"patch_type": "hand",
					"origin_patch_type": "hand",
					"patch_directory": "hand",
					"z_index": 3000,
					"price": 400,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				}
			]
		},

		{
			"title": "Summer Sale",
			"description": "A few summer items are now available for you to buy. Will you choose a beach ball or some patriotic sunglasses?",
			"start_month": 7,
			"start_day": 1,
			"end_month": 7,
			"end_day": 14,
			"patches": [
				{
					"name": "glasses-star",
					"title": "Liberty Glasses",
					"description": "These patriotic star glasses are great for days full of fireworks, trips to the pool, and tasty BBQ. Wear these when you're feeling liberated!",
					"source": "special",
					"patch_type": "face",
					"origin_patch_type": "face",
					"patch_directory": "face",
					"z_index": 3100,
					"price": 100,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				},
				{
					"name": "hat-anchor",
					"title": "Sailor Hat",
					"description": "Sailboats are incredibly beautiful boats, and are also fun to steer! Grab your anchor hat and sail away. Don't forget your real anchor, so you can float at sea and watch the sunset.",
					"source": "special",
					"patch_type": "head",
					"origin_patch_type": "head",
					"patch_directory": "head",
					"z_index": 1400,
					"price": 60,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				},
				{
					"name": "watermelon",
					"title": "Melonhead",
					"description": "Watermelons are a tasty summer treat, but owls also love to wear them on their heads! No one is quite sure why...",
					"source": "special",
					"patch_type": "head",
					"origin_patch_type": "head",
					"patch_directory": "head",
					"z_index": 1400,
					"price": 100,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				},
				{
					"name": "kite",
					"title": "Kite",
					"description": "Whoever said windy days can't be fun?! Take this kite to the beach and let it fly, spin, and twirl!",
					"source": "special",
					"patch_type": "body",
					"origin_patch_type": "body",
					"patch_directory": "body",
					"z_index": 1500,
					"price": 60,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				},
				{
					"name": "shirt-crab",
					"title": "Cool Crab Shirt",
					"description": "Wear this shirt when you're feeling cool, because this crab is as cool as it gets. He has traveled the world to visit every beach on Earth. Are you jealous?",
					"source": "special",
					"patch_type": "body",
					"origin_patch_type": "body",
					"patch_directory": "body",
					"z_index": 1500,
					"price": 40,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				},
				{
					"name": "shirt-surfboards",
					"title": "Surf Shirt",
					"description": "This shirt is perfect for that epic beach party. Show your friends that you know what's up when it comes to beachy attire. Maybe even pair it with a real surfboard for extra points.",
					"source": "special",
					"patch_type": "body",
					"origin_patch_type": "body",
					"patch_directory": "body",
					"z_index": 1500,
					"price": 40,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				},
				{
					"name": "ball-beach",
					"title": "Beach Ball",
					"description": "This inflatable beach ball is fun at the beach, pool, picnic, playground and more! Keep this ball around and you'll always have a great time.",
					"source": "special",
					"patch_type": "hand",
					"origin_patch_type": "hand",
					"patch_directory": "hand",
					"z_index": 3000,
					"price": 100,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				},
				{
					"name": "ball-volleyball",
					"title": "My Friend, Wilson",
					"description": "This ball makes for a great game of volleyball, and it doubles as a friend when you're in need! His name is Wilson, and he's a great listener.",
					"source": "special",
					"patch_type": "hand",
					"origin_patch_type": "hand",
					"patch_directory": "hand",
					"z_index": 3000,
					"price": 60,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				},
				{
					"name": "pineapple",
					"title": "The Apple of the Beach",
					"description": "You won't need a ladder to harvest this fruit. Nope. Pineapples are not apples that grow on pine trees. Actually, they grow on a plant close to the ground, and each pineapple plant bears exactly one pineapple.",
					"source": "special",
					"patch_type": "hand",
					"origin_patch_type": "hand",
					"patch_directory": "hand",
					"z_index": 3000,
					"price": 80,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				},
				{
					"name": "beach",
					"title": "Feet in the Sand",
					"description": "If your heart belongs at the beach, follow your dreams and buy this so you can always have your feet in the sand. Build an epic sand castle while you're at it!",
					"source": "special",
					"patch_type": "feet",
					"origin_patch_type": "feet",
					"patch_directory": "feet",
					"z_index": 800,
					"price": 200,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				}
			]
		},

		{
			"title": "Back-to-School Sale",
			"description": "A few back-to-school items are now available for you to buy. Will you choose a new tablet or a delicious red apple?",
			"start_month": 8,
			"start_day": 7,
			"end_month": 8,
			"end_day": 29,
			"start_time": "2020-08-07T23:59:59+00:00",
			"end_time": "2020-09-17T23:59:59+00:00",
			"patches": [
				{
					"name": "apple",
					"title": "Teacher's Apple",
					"description": "Teachers are owlsome people. Show your love for your teacher and give them a shiny apple.",
					"source": "special",
					"patch_type": "beak",
					"origin_patch_type": "beak",
					"patch_directory": "beak",
					"z_index": 3000,
					"price": 60,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				},
				{
					"name": "backpack",
					"title": "Hipster Backpack",
					"description": "Not only is this backpack the most stylish one at school that no one else has, but it can also fit anything. It can hold three elephants and a boat!",
					"source": "special",
					"patch_type": "body",
					"origin_patch_type": "body",
					"patch_directory": "body",
					"z_index": 4000,
					"price": 40,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				},
				{
					"name": "book-shelf",
					"title": "Discovery Shelf",
					"description": "This magical bookshelf contains any book that's ever been written, including the Enchanted Broccoli Forest.",
					"source": "special",
					"patch_type": "body",
					"origin_patch_type": "body",
					"patch_directory": "body",
					"z_index": 800,
					"price": 100,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				},
				{
					"name": "calculator",
					"title": "Newton's Calculator",
					"description": "Once you have this calculator, you will become the master of numbers, just like the great Isaac Newton. You will be able to solve any equation!",
					"source": "special",
					"patch_type": "hand",
					"origin_patch_type": "hand",
					"patch_directory": "hand",
					"z_index": 3000,
					"price": 60,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				},
				{
					"name": "crayons",
					"title": "DaVinci's Crayons",
					"description": "The great Leonardo DaVinci was a crayon expert before was a great painter. Follow in his footsteps with these famous crayons.",
					"source": "special",
					"patch_type": "hand",
					"origin_patch_type": "hand",
					"patch_directory": "hand",
					"z_index": 3000,
					"price": 40,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				},
				{
					"name": "scissors",
					"title": "Creativity Scissors",
					"description": "With these scissors, your creativity powers will soar. You can do any art project and make any outfit!",
					"source": "special",
					"patch_type": "hand",
					"origin_patch_type": "hand",
					"patch_directory": "hand",
					"z_index": 3000,
					"price": 40,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				},
				{
					"name": "spiral-notebook",
					"title": "Shakespeare's Notebook",
					"description": "Shakespeare wrote some of the greatest plays of all time in this notebook, including Rome-Owl and Juliet. With this notebook, you will have the power to write stories that will be read far in the future.",
					"source": "special",
					"patch_type": "hand",
					"origin_patch_type": "hand",
					"patch_directory": "hand",
					"z_index": 3000,
					"price": 80,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				},
				{
					"name": "tablet",
					"title": "Tablet of Wonder",
					"description": "This is a special tablet. Not only can you watch videos and play games, but you can read any text and create apps on it for your friends.",
					"source": "special",
					"patch_type": "hand",
					"origin_patch_type": "hand",
					"patch_directory": "hand",
					"z_index": 3000,
					"price": 100,
					"tier": 0,
					"offsets": null,
					"animation": null,
					"extra_right": 0,
					"extra_left": 0,
					"extra_top": 0,
					"extra_bottom": 0
				}
			]
		},
		{
			"title": "Owl-O-Ween Sale",
			"description": "Mummies and pumpkins and bats, oh my! Spook your friends with these scary Halloween items.",
			"start_month": 9,
			"start_day": 18,
			"end_month": 10,
			"end_day": 2,
			"patches": [
				{
			      "name": "bat",
			      "title": "Spooky Bat",
			      "description": "Keep a close watch on this bat. You never know if he is your friend or your enemy...",
			      "source": "special",
			      "patch_type": "hand",
			      "origin_patch_type": "hand",
			      "patch_directory": "hand",
			      "z_index": 3000,
			      "price": 40,
			      "tier": 0,
			      "offsets": null,
			      "animation": null,
			      "extra_right": 0,
			      "extra_left": 0,
			      "extra_top": 0,
			      "extra_bottom": 0
				},
				{
				  "name": "candy",
				  "title": "Owl-O-Ween Candy",
				  "description": "The very best part of Owl-O-Ween: creepy candy!",
				  "source": "special",
				  "patch_type": "hand",
				  "origin_patch_type": "hand",
				  "patch_directory": "hand",
				  "z_index": 3000,
				  "price": 100,
				  "tier": 0,
				  "offsets": null,
				  "animation": null,
				  "extra_right": 0,
				  "extra_left": 0,
				  "extra_top": 0,
				  "extra_bottom": 0
				},
				{
			      "name": "cauldron",
			      "title": "Magical Cauldron",
			      "description": "This creepy cauldron is perfect for brewing up your own potions.",
			      "source": "special",
			      "patch_type": "body",
			      "origin_patch_type": "body",
			      "patch_directory": "body",
			      "z_index": 2500,
			      "price": 100,
			      "tier": 0,
			      "offsets": null,
			      "animation": null,
			      "extra_right": 0,
			      "extra_left": 0,
			      "extra_top": 0,
			      "extra_bottom": 0
			    },
			    {
		          "name": "dracula-cape",
		          "title": "Dracula's Cape",
		          "description": "This is the cape of the ledendary Count himself. Be careful... he might come back for it.",
		          "source": "special",
		          "patch_type": "body",
		          "origin_patch_type": "body",
		          "patch_directory": "body",
		          "z_index": 1500,
		          "price": 80,
		          "tier": 0,
		          "offsets": null,
		          "animation": null,
		          "extra_right": 0,
		          "extra_left": 0,
		          "extra_top": 0,
		          "extra_bottom": 0
			    },
				{
			      "name": "hat-witch",
			      "title": "Basic Witch Hat",
			      "description": "Did you forget it's Halloween? This hat is perfect for owls who need an easy costume.",
			      "source": "special",
			      "patch_type": "head",
			      "origin_patch_type": "head",
			      "patch_directory": "head",
			      "z_index": 1400,
			      "price": 40,
			      "tier": 0,
			      "offsets": null,
			      "animation": null,
			      "extra_right": 0,
			      "extra_left": 0,
			      "extra_top": 15,
			      "extra_bottom": 0
				},
				{
			      "name": "outfit-witch",
			      "title": "Wicked Witch of the West Dress",
			      "description": "Bring back the Wicked Witch of the West with this dress... just stay away from water so you don't melt.",
			      "source": "special",
			      "patch_type": "body",
			      "origin_patch_type": "body",
			      "patch_directory": "body",
			      "z_index": 1500,
			      "price": 60,
			      "tier": 0,
			      "offsets": null,
			      "animation": null,
			      "extra_right": 0,
			      "extra_left": 0,
			      "extra_top": 0,
			      "extra_bottom": 0
				},
				{
			      "name": "pumpkin",
			      "title": "Jack-Owl-Lantern",
			      "description": "Show off your pumpkin-carving skills with this perfectly carved Jack-Owl-Lantern. Candle not included.",
			      "source": "special",
			      "patch_type": "hand",
			      "origin_patch_type": "hand",
			      "patch_directory": "hand",
			      "z_index": 3000,
			      "price": 80,
			      "tier": 0,
			      "offsets": null,
			      "animation": null,
			      "extra_right": 0,
			      "extra_left": 0,
			      "extra_top": 0,
			      "extra_bottom": 0
				},
				{
			      "name": "wizard-hat",
			      "title": "Hocus Pocus Hat",
			      "description": "Even the very best wizards and witches practice their spells daily. Wearing this hat helps you remember your magic.",
			      "source": "special",
			      "patch_type": "head",
			      "origin_patch_type": "head",
			      "patch_directory": "head",
			      "z_index": 1400,
			      "price": 80,
			      "tier": 0,
			      "offsets": null,
			      "animation": null,
			      "extra_right": 0,
			      "extra_left": 0,
			      "extra_top": 20,
			      "extra_bottom": 0
				},
				{
			      "name": "spider",
			      "title": "Spider Pet",
			      "description": " Oh no! A spider landed on your head. Don't be scared, it's a friendly spider. Why not give it a name?",
			      "source": "special",
			      "patch_type": "head",
			      "origin_patch_type": "head",
			      "patch_directory": "head",
			      "z_index": 1400,
			      "price": 80,
			      "tier": 0,
			      "offsets": null,
			      "animation": null,
			      "extra_right": 0,
			      "extra_left": 0,
			      "extra_top": 0,
			      "extra_bottom": 0
				},
				{
			      "name": "ghost",
			      "title": "Ghost Costume",
			      "description": "Haunt your Class Tree with this scary ghost costume. Then tell your friends not to worry, it's just an old white sheet afterall.",
			      "source": "special",
			      "patch_type": "body",
			      "origin_patch_type": "body",
			      "patch_directory": "body",
			      "z_index": 1700,
			      "price": 180,
			      "tier": 0,
			      "offsets": null,
			      "animation": null,
			      "extra_right": 0,
			      "extra_left": 0,
			      "extra_top": 0,
			      "extra_bottom": 0
				},
				{
			      "name": "night-sky",
			      "title": "Night Sky",
			      "description": "Owls love the night. Make yourself at home under the moon and stars. Fly high and call out to your friends in the dark with a hoot.",
			      "source": "special",
			      "patch_type": "feet",
			      "origin_patch_type": "feet",
			      "patch_directory": "feet",
			      "z_index": 300,
			      "price": 180,
			      "tier": 0,
			      "offsets": null,
			      "animation": null,
			      "extra_right": 0,
			      "extra_left": 0,
			      "extra_top": 32,
			      "extra_bottom": 0
				},
				// {
			 //      "name": "mummy-hand",
			 //      "title": "Mummy Costume Wing",
			 //      "description":  "Two-for-one! Buy this mummy wing and use it for both of your wings.",
			 //      "source": "special",
			 //      "patch_type": "hand",
			 //      "origin_patch_type": "hand",
			 //      "patch_directory": "hand",
			 //      "z_index": 3000,
			 //      "price": 60,
			 //      "tier": 0,
			 //      "offsets": null,
			 //      "animation": null,
			 //      "extra_right": 0,
			 //      "extra_left": 0,
			 //      "extra_top": 0,
			 //      "extra_bottom": 0
				// },
				// {
			 //      "name": "mummy-head",
			 //      "title": "Mummy Costume Hat",
			 //      "description": "The only thing spookier than an owl on Halloween is an owl dressed up as a mummy!",
			 //      "source": "special",
			 //      "patch_type": "head",
			 //      "origin_patch_type": "head",
			 //      "patch_directory": "head",
			 //      "z_index": 1400,
			 //      "price": 60,
			 //      "tier": 0,
			 //      "offsets": null,
			 //      "animation": null,
			 //      "extra_right": 0,
			 //      "extra_left": 0,
			 //      "extra_top": 0,
			 //      "extra_bottom": 0
				// } ,
				// {
			 //      "name": "mummy-body",
			 //      "title": "Mummy Costume",
			 //      "description":  "Make sure to buy the matching hat and wings to complete this mummy costume for your owl!",
			 //      "source": "special",
			 //      "patch_type": "body",
			 //      "origin_patch_type": "body",
			 //      "patch_directory": "body",
			 //      "z_index": 1500,
			 //      "price": 40,
			 //      "tier": 0,
			 //      "offsets": null,
			 //      "animation": null,
			 //      "extra_right": 0,
			 //      "extra_left": 0,
			 //      "extra_top": 0,
			 //      "extra_bottom": 0
				// } 	  
				{
				  "name": "zombie-bolts",
				  "title": "Zombie Bolts",
				  "description": "These bolts help to hold your zombie head together so you can keep all those wise ideas inside.",
				  "source": "special",
				  "patch_type": "head",
				  "origin_patch_type": "head",
				  "patch_directory": "head",
				  "z_index": 1400,
				  "price": 140,
				  "tier": 0,
				  "offsets": null,
				  "animation": null,
				  "extra_right": 0,
				  "extra_left": 0,
				  "extra_top": 0,
				  "extra_bottom": 0
				},
				{
				  "name": "zombie-glasses",
				  "title": "Zombie Glasses",
				  "description": "Put on these glasses to scare your friends. They'll think you've come back to life as a zombie!",
				  "source": "special",
				  "patch_type": "face",
				  "origin_patch_type": "face",
				  "patch_directory": "face",
				  "z_index": 3100,
				  "price": 100,
				  "tier": 0,
				  "offsets": null,
				  "animation": null,
				  "extra_right": 0,
				  "extra_left": 0,
				  "extra_top": 0,
				  "extra_bottom": 0
				},
				{
				  "name": "zombie-stitches",
				  "title": "Zombie Stitches",
				  "description": "Some zombies are put back together by a mad scientist, which leads to these scary stitches.",
				  "source": "special",
				  "patch_type": "body",
				  "origin_patch_type": "body",
				  "patch_directory": "body",
				  "z_index": 1500,
				  "price": 180,
				  "tier": 0,
				  "offsets": null,
				  "animation": null,
				  "extra_right": 0,
				  "extra_left": 0,
				  "extra_top": 0,
				  "extra_bottom": 0
				}
			]
		}
	],

	getCurrentSale() {
		var now = new Date()
		var currentSales =  _.find(ShopSales.SALES, function(saleData) {
			var dates = ShopSales.getSaleDates(saleData)
			var endDate = dates["end"]
			var startDate = dates["start"]
			return now < endDate && now > startDate 
		});
		return currentSales
	},

	hasCurrentSale() {
		return this.getCurrentSale() != null;
	},

	isOnSale(patchType, patchName) {
		var currentSale = this.getCurrentSale();
		if (currentSale) {
			return !!_.find(currentSale.patches, function(patchData) {
				return (patchData.name == patchName) && (patchData.patch_type == patchType);
			});
		} else {
			return false;
		}
	},

	getSaleDates(sale){
		if (sale){
			var now = new Date()
			if (sale.title == "Owl-idays Sale"){
				var month = now.getMonth()
				var day = now.getDay()
				// if january, need to check if we are still in last years holiday sale
				if (month == 0 && sale.end_day >= day){
					return {
						"start" : new Date(now.getFullYear() - 1 , sale.start_month, sale.start_day), 
						"end" : new Date(now.getFullYear(), sale.end_month, sale.end_day)
					}
				}
				else {
					return {
						"start" : new Date(now.getFullYear(), sale.start_month, sale.start_day), 
						"end" : new Date(now.getFullYear() + 1, sale.end_month, sale.end_day)
					}
				}	
			}
			else{
				return {
					"start" : new Date(now.getFullYear(), sale.start_month, sale.start_day),
					"end" : new Date(now.getFullYear(), sale.end_month, sale.end_day)
				}
			}
		}
	},

	getSaleBanner(){
		var currentHoliday = this.getCurrentSale()
		if (!currentHoliday){
			return
		}
		var name = currentHoliday.title

		if (name == "Owl-idays Sale"){
			return DecemberSaleImage
		}
		else if (name=="Summer Sale"){
			return JulySaleImage
		}
		else if (name=="Back-to-School Sale"){
			return SeptemberSaleImage
		}
		else if (name == "Owl-O-Ween Sale"){
			return OctoberSaleImage
		}
	}

}

module.exports = ShopSales;



// WEBPACK FOOTER //
// ./modules/lib/games/ShopSales.js